import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutJournalDriver extends Layout {
    sourceJournalDriver: DataSource;
    tableJournalDriver: Table;
}
